exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-16d4c61c]{padding-top:40px\n}\n@media only screen and (min-width:768px){\n.container[data-v-16d4c61c] .allColorsRow{max-height:417px!important\n}\n}\n@media only screen and (min-width:992px){\n.container[data-v-16d4c61c] .allColorsRow{max-height:550px!important\n}\n}\n@media only screen and (min-width:1200px){\n.container[data-v-16d4c61c] .allColorsRow{max-height:644px!important\n}\n}\nimg[data-v-16d4c61c]{max-width:100%\n}\nh1[data-v-16d4c61c]{font-size:1.4rem\n}\n.indhold[data-v-16d4c61c]{line-height:22px\n}\n.indhold[data-v-16d4c61c] h2{font-size:1.125rem\n}\n.indhold[data-v-16d4c61c] h3{font-size:.96rem\n}", ""]);

// exports
